import { RouterProvider } from 'react-router-dom'
import { bootstrapAuth } from './bootstrap-auth'
import { createAppRouter } from './router'
import { GlobalUiShell } from '@/shared/components'

bootstrapAuth()
const appRouter = createAppRouter()

export const App = () => {
  return (
    <GlobalUiShell>
      <RouterProvider router={appRouter} />
    </GlobalUiShell>
  )
}
